export enum LPCO_TABLE_NAME {
  NEW_REQUESTS = 'NEW_REQUESTS',
  LIST = 'LIST',
}
